const checkIfEmptyArray = (Array?: any[]) => {
    if (!Array) return true
    return Array?.length === 0;
}

export {checkIfEmptyArray}